import { z } from 'zod'

import { schemas } from '~interface/zod-schema'

export type Address0 = z.infer<typeof schemas.Address0>

export type GeoPoint = z.infer<typeof schemas.GeoPoint>

export type Location0 = z.infer<typeof schemas.Location0>

export function formatAddress0(address: Address0): string {
  return `${address.street}, ${address.city}, ${address.state} ${address.zip}`
}
